module.exports = __webpack_public_path__ + "assets/img/d18393c29e5a5449e77b6e9b45dda922.png";